export const COLLECTION_CONTROLE_RESIDUOS = "tblControleResiduos";

export const CAMPOS_RESIDUO = [
  ["tipoResiduo", "Tipo de resíduo"],
  ["classeResiduo", "Classe do resíduo"],
  ["mesReferencia", "Mês de referência"],
  ["origemSetor", "Origem/Setor"],
  ["quantidadeTotal", "Quant. total"],
  ["unidade", "Unidade"],
  ["destinacaoFinal", "Destinação final"],
];

const residuo = (tipoResiduo, classeResiduo, mesReferencia, origemSetor, quantidadeTotal, unidade, destinacaoFinal) => ({
  tipoResiduo, classeResiduo, mesReferencia, origemSetor, quantidadeTotal, unidade, destinacaoFinal,
});

export const RESIDUOS_INICIAIS = [
  residuo("Corpos de prova de concreto", "Classe II B - Inertes", "agosto de 2025", "Ensaios compressão", "2350", "Und", "Construção do tanque de cura úmida"),
  residuo("Luvas de látex Kalipso", "Classe II A - Não perigosos e não inertes", "agosto de 2025", "Controle tecnológico", "20", "Pares", "Setor público de coleta e recicláveis"),
  residuo("Luvas de pano pigmentada", "Classe II A - Não perigosos e não inertes", "agosto de 2025", "Controle tecnológico", "14", "Pares", "Setor público de coleta e recicláveis"),
  residuo("Folhas sulfite A4", "Resíduos administrativos", "agosto de 2025", "Controle tecnológico", "120", "Und", "Filtro para moldagem de corpo de prova"),
  residuo("Lâmpadas de LED ou fluorescentes", "Classe I - Perigosos", "agosto de 2025", "Troca interna no laboratório", "", "Und", "Setor público de coleta e recicláveis"),
  residuo("Disco de neoprene", "Classe II B - Inertes", "agosto de 2025", "Ensaio de compressão", "", "Und", "Setor público de coleta e recicláveis"),
  residuo("Luvas de látex Kalipso", "Classe II A - Não perigosos e não inertes", "setembro de 2025", "Controle tecnológico", "", "Pares", "Setor público de coleta e recicláveis"),
  residuo("Luvas de pano pigmentada", "Classe II A - Não perigosos e não inertes", "setembro de 2025", "Controle tecnológico", "", "Pares", "Setor público de coleta e recicláveis"),
  residuo("Lâmpadas de LED ou fluorescentes", "Classe I - Perigosos", "setembro de 2025", "Troca interna no laboratório", "", "Und", "Setor público de coleta e recicláveis"),
].map((item, indice) => ({ item: indice + 1, ...item }));

export const novoResiduo = (item) => Object.fromEntries([
  ["item", item],
  ...CAMPOS_RESIDUO.map(([campo]) => [campo, ""]),
]);
